import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { HomeComponent } from './public/home/home.component';
import { ModulesComponent } from './modules/modules.component';
import { EditorComponent } from './editor/editor.component';
import { DefaultComponent } from './layouts/default/default.component';
import { ModalComponent } from './layouts/modal/modal.component';
import { SignupComponent } from './authentication/signup/signup.component';
import { LoginComponent } from './authentication/login/login.component';
import { DashboardComponent } from './protected/dashboard/dashboard.component';
import { EditProfileComponent } from './protected/modal/edit-profile/edit-profile.component';
import { GuideComponent } from './protected/modal/guide/guide.component';
import { ForumComponent } from './protected/forum/forum.component';
import { ResourcesComponent } from './protected/resources/resources.component';
import { MembersComponent } from './protected/members/members.component';
import { InstitutionsComponent } from './protected/institutions/institutions.component';
import { ProjectService } from './services/project.service';
import { ProjectsComponent } from './protected/projects/projects.component';
import { EventsComponent } from './protected/events/events.component';
import { JobsComponent } from './protected/jobs/jobs.component';
import { InviteComponent } from './protected/modal/invite/invite.component';
import { EditDiscussionComponent } from './protected/modal/edit-discussion/edit-discussion.component';
import { EditInstitutionComponent } from './protected/modal/edit-institution/edit-institution.component';
import { EditProjectComponent } from './protected/modal/edit-project/edit-project.component';
import { EditResourceComponent } from './protected/modal/edit-resource/edit-resource.component';
import { EditEventComponent } from './protected/modal/edit-event/edit-event.component';
import { SettingsComponent } from './protected/settings/settings.component';
import { EditJobComponent } from './protected/modal/edit-job/edit-job.component';
import { AddDiscussionComponent } from './protected/modal/add-discussion/add-discussion.component';
import { ForumSingleComponent } from './protected/forum/forum-single/forum-single.component';
import { ProjectSingleComponent } from './protected/projects/project-single/project-single.component';
import { MyListsComponent } from './protected/my-lists/my-lists.component';
import { SingleMemberComponent } from './protected/members/single-member/single-member.component';
import { AddResourceComponent } from './protected/modal/add-resource/add-resource.component';
import { ResourceSingleComponent } from './protected/resources/resource-single/resource-single.component';
import { JobsSingleComponent } from './protected/jobs/jobs-single/jobs-single.component';
import { EventsSingleComponent } from './protected/events/events-single/events-single.component';
import { InstitutionsSingleComponent } from './protected/institutions/institutions-single/institutions-single.component';
import { ApproachesComponent } from './public/approaches/approaches.component';
import { ApproachesSingleComponent } from './public/approaches/approaches-single/approaches-single.component';
import { AboutComponent } from './public/about/about.component';
import { TransferRolesComponent } from './protected/modal/transfer-roles/transfer-roles.component';
import { DisabledComponent } from './protected/modal/disabled/disabled.component';
import { NotificationsComponent } from './protected/notifications/notifications.component';
import { PrivacyComponent } from './protected/modal/privacy/privacy.component';
import { TermsComponent } from './protected/modal/terms/terms.component';
import { DisclaimerComponent } from './protected/modal/disclaimer/disclaimer.component';
import { AuthGuard } from './services/auth-guard.service';
import { UserDeletedComponent } from './protected/modal/user-deleted/user-deleted.component';

const routes: Routes = [
  {
    path: '',
    component: DefaultComponent,
    children: [
      {
        path: '',
        component: HomeComponent,
      },
      {
        path: 'roadmaps',
        component: ApproachesComponent,
      },
      {
        path: 'approaches/:id',
        component: ApproachesSingleComponent,
      },
      {
        path: 'about',
        component: AboutComponent,
        data: {
          group: 'community'
        }
      },
      {
        path: 'modules',
        component: ModulesComponent,
      },
      {
        path: 'editor',
        component: EditorComponent,
      },
      {
        path: 'dashboard',
        canActivate: [AuthGuard],
        component: DashboardComponent,
      },
      {
        path: 'forum',
        component: ForumComponent,
      },
      {
        path: 'forum/:id',
        component: ForumSingleComponent,
      },
      {
        path: 'resources',
        component: ResourcesComponent,
        data: {
          group: 'community'
        }
      },
      {
        path: 'resources/:id',
        component: ResourceSingleComponent,
        data: {
          group: 'community'
        }
      },
      {
        path: 'members',
        component: MembersComponent,
        data: {
          group: 'community'
        }
      },
      {
        path: 'member/:id',
        component: SingleMemberComponent,
        data: {
          group: 'community'
        }
      },
      {
        path: 'institutions',
        component: InstitutionsComponent,
        data: {
          group: 'community'
        }
      },
      {
        path: 'institutions/:id',
        component: InstitutionsSingleComponent,
        data: {
          group: 'community'
        }
      },
      {
        path: 'projects',
        component: ProjectsComponent,
      },
      {
        path: 'projects/:id',
        component: ProjectSingleComponent,
      },
      {
        path: 'events',
        component: EventsComponent,
        data: {
          group: 'community'
        }
      },
      {
        path: 'events/:id',
        component: EventsSingleComponent,
        data: {
          group: 'community'
        }
      },
      {
        path: 'jobs',
        component: JobsComponent,
        data: {
          group: 'community'
        }
      },
      {
        path: 'jobs/:id',
        component: JobsSingleComponent,
        data: {
          group: 'community'
        }
      },
      {
        path: 'settings/:action',
        canActivate: [AuthGuard],
        component: SettingsComponent,
      },
      {
        path: 'settings',
        canActivate: [AuthGuard],
        component: SettingsComponent,
      },
      {
        path: 'my/:id',
        canActivate: [AuthGuard],
        component: MyListsComponent,
        data: {
          group: 'community'
        }
      },
      {
        path: 'notifications',
        canActivate: [AuthGuard],
        component: NotificationsComponent,
      },
    ],
  },
  {
    path: 'm',
    component: ModalComponent,
    children: [
      {
        path: 'signup',
        component: SignupComponent,
        data: {
          leftAction: 'back',
          rightAction: 'login',
          innerWidth: 6,
        },
      },
      {
        path: 'login',
        component: LoginComponent,
        data: {
          leftAction: 'back',
          rightAction: 'signup',
          innerWidth: 6,
        },
      },
      {
        path: 'edit-profile',
        component: EditProfileComponent,
        canActivate: [AuthGuard],
        data: {
          leftAction: '',
          rightAction: 'exit',
          innerWidth: 6,
        },
      },
      {
        path: 'guide',
        component: GuideComponent,
        data: {
          leftAction: '',
          rightAction: 'exit',
          innerWidth: 8,
        },
      },
      {
        path: 'invite',
        component: InviteComponent,
        canActivate: [AuthGuard],
        data: {
          leftAction: '',
          rightAction: 'exit',
          innerWidth: 6,
        },
      },
      {
        path: 'edit-discussion',
        component: EditDiscussionComponent,
        canActivate: [AuthGuard],
        data: {
          leftAction: '',
          rightAction: 'exit',
          innerWidth: 6,
        },
      },
      {
        path: 'edit-institution',
        component: EditInstitutionComponent,
        canActivate: [AuthGuard],
        data: {
          leftAction: '',
          rightAction: 'exit',
          innerWidth: 6,
        },
      },
      {
        path: 'edit-project',
        component: EditProjectComponent,
        canActivate: [AuthGuard],
        data: {
          leftAction: '',
          rightAction: 'exit',
          innerWidth: 6,
        },
      },
      {
        path: 'edit-resource',
        component: EditResourceComponent,
        canActivate: [AuthGuard],
        data: {
          leftAction: '',
          rightAction: 'exit',
          innerWidth: 6,
        },
      },
      {
        path: 'edit-event',
        component: EditEventComponent,
        canActivate: [AuthGuard],
        data: {
          leftAction: '',
          rightAction: 'exit',
          innerWidth: 6,
        },
      },
      {
        path: 'edit-job',
        component: EditJobComponent,
        canActivate: [AuthGuard],
        data: {
          leftAction: '',
          rightAction: 'exit',
          innerWidth: 6,
        },
      },
      {
        path: 'add-discussion',
        component: AddDiscussionComponent,
        canActivate: [AuthGuard],
        data: {
          leftAction: '',
          rightAction: 'exit',
          innerWidth: 6,
          rightWidth: 'auto'
        },
      },
      {
        path: 'add-resource',
        component: AddResourceComponent,
        canActivate: [AuthGuard],
        data: {
          leftAction: '',
          rightAction: 'exit',
          innerWidth: 6,
          rightWidth: true
        },
      },
      {
        path: 'transfer-roles',
        component: TransferRolesComponent,
        canActivate: [AuthGuard],
        data: {
          leftAction: '',
          rightAction: 'exit',
          innerWidth: 6,
        },
      },
      {
        path: 'disabled',
        component: DisabledComponent,
        canActivate: [AuthGuard],
        data: {
          leftAction: '',
          rightAction: 'logout',
          innerWidth: 6,
        },
      },
      {
        path: 'privacy-policy',
        component: PrivacyComponent,
        canActivate: [AuthGuard],
        data: {
          leftAction: '',
          rightAction: 'exit',
          innerWidth: 6,
        },
      },
      {
        path: 'terms-conditions',
        component: TermsComponent,
        data: {
          leftAction: '',
          rightAction: 'exit',
          innerWidth: 6,
        },
      },
      {
        path: 'disclaimer',
        component: DisclaimerComponent,
        data: {
          leftAction: '',
          rightAction: 'exit',
          innerWidth: 6,
        },
      },
      {
        path: 'user-deleted',
        component: UserDeletedComponent,
        canActivate: [AuthGuard],
        data: {
          leftAction: '',
          rightAction: '',
          innerWidth: 6,
        },
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule { }
